"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToastActionStyled = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _toastTheme = require("./toastTheme");
const ToastActionStyled = (0, _styled.default)("button")`
    display: inline-flex;
    align-items: center;
    box-sizing: border-box;
    height: 32px;
    min-width: 32px;
    padding: ${_ref => {
  let {
    themeMode
  } = _ref;
  return _toastTheme.toastTheme.actionButton.padding(themeMode);
}};
    border: none;
    border-radius: ${_ref2 => {
  let {
    themeMode
  } = _ref2;
  return _toastTheme.toastTheme.borderRadius(themeMode);
}}};
    cursor: pointer;
    font-weight: 600;
    color: currentColor;

    display: inline-flex;
    align-items: center;
    justify-content: space-around;
    white-space: nowrap;

    background-color: transparent;

    &:hover {
        background-color: ${_ref3 => {
  let {
    themeMode
  } = _ref3;
  return _toastTheme.toastTheme.actionButton.backgroundColor.hover(themeMode);
}};
    }

    &:active {
        background-color: ${_ref4 => {
  let {
    themeMode
  } = _ref4;
  return _toastTheme.toastTheme.actionButton.backgroundColor.pressed(themeMode);
}};
    }

`;
exports.ToastActionStyled = ToastActionStyled;
//# sourceMappingURL=ToastActionStyled.js.map